import { jsxs as B, jsx as l } from "react/jsx-runtime";
import A, { useRef as G, useEffect as M, useId as ea, useState as X, createContext as ta, useContext as ra } from "react";
import { z as a } from "zod";
import { withZod as y } from "@made-people/react-prop-guard";
import { swiperNavigationBlueprint as la, swiperPaginationDotsBlueprint as na, swiperPaginationProgressBarBlueprint as ia, swiperPaginationNumbersBlueprint as sa, swiperPaginationScrollBar as ca, swiperPaginationBlueprint as pa, swiperListBlueprint as ua, swiperTemplate1Blueprint as ma, swiperFunctionalityBlueprint as da, swiperSpacingBlueprint as ba } from "./index-blueprint.es.js";
import { useBreakpointVisibility as $ } from "@made-people/blueprint-ui-hooks";
import { withManagedProps as k } from "@made-people/managed-props";
import J, { clsx as j } from "clsx";
import { linkAsLinkSchema as E, LinkAsLink as K } from "@made-people/blueprint-link";
import { headingSchema as ha, Heading as wa } from "@made-people/blueprint-heading";
import "@made-people/blueprint";
const Q = a.object({
  variants: a.custom().optional(),
  templateBlueprint: a.custom().optional(),
  prevIcon: a.custom().optional(),
  nextIcon: a.custom().optional(),
  leftOffset: a.enum(["gutter", "edge"]).optional(),
  rightOffset: a.enum(["gutter", "edge"]).optional(),
  mobile: a.union([
    a.object({
      enabled: a.boolean().optional(),
      template: a.union([a.literal("arrows"), a.undefined()])
    }),
    a.undefined()
  ]),
  desktop: a.union([
    a.object({
      enabled: a.boolean().optional(),
      template: a.union([a.literal("arrows"), a.undefined()])
    }),
    a.undefined()
  ]),
  "aria-controls": a.string().optional(),
  "aria-label": a.string().optional()
}), F = k(
  "SwiperNavigation",
  y(
    Q,
    ({
      variants: p,
      templateBlueprint: o,
      "aria-controls": r,
      "aria-label": e
    }) => {
      var C, w, S, N, L, D, I, O, x, T, Z, q, z;
      const {
        totalSlides: n,
        currentSlide: d,
        settings: t,
        containerWidth: f,
        scrollX: s,
        handleScroll: b
      } = P(), u = o ?? la, m = {
        ...(C = t == null ? void 0 : t.navigation) == null ? void 0 : C.variants,
        ...p,
        ...(w = t == null ? void 0 : t.navigation) != null && w.leftOffset ? { leftOffset: t.navigation.leftOffset } : {},
        ...(S = t == null ? void 0 : t.navigation) != null && S.rightOffset ? { rightOffset: t.navigation.rightOffset } : {}
      }, c = Object.keys(m).length > 0, i = u.styles(
        c ? m : void 0
      );
      if (!b || !((L = (N = t == null ? void 0 : t.navigation) == null ? void 0 : N.mobile) != null && L.enabled) && !((I = (D = t == null ? void 0 : t.navigation) == null ? void 0 : D.desktop) != null && I.enabled))
        return null;
      const g = $({
        mobile: (x = (O = t == null ? void 0 : t.navigation) == null ? void 0 : O.mobile) == null ? void 0 : x.enabled,
        tablet: null,
        desktop: (Z = (T = t == null ? void 0 : t.navigation) == null ? void 0 : T.desktop) == null ? void 0 : Z.enabled
      }), v = s < 200, W = d === n - 1 || f - s < 200;
      return /* @__PURE__ */ B(
        "div",
        {
          className: i.wrapper,
          ...g,
          role: "group",
          "aria-label": e || "Carousel navigation controls",
          children: [
            /* @__PURE__ */ l(
              "button",
              {
                className: i.leftArrow,
                disabled: v,
                onClick: () => b("left"),
                "aria-label": "Previous slide",
                "aria-controls": r,
                "aria-disabled": v,
                children: (q = t == null ? void 0 : t.navigation) == null ? void 0 : q.prevIcon
              }
            ),
            /* @__PURE__ */ l(
              "button",
              {
                className: i.rightArrow,
                disabled: W,
                onClick: () => b("right"),
                "aria-label": "Next slide",
                "aria-controls": r,
                "aria-disabled": W,
                children: (z = t == null ? void 0 : t.navigation) == null ? void 0 : z.nextIcon
              }
            )
          ]
        }
      );
    }
  )
), va = a.object({
  variants: a.custom().optional()
}), fa = k(
  "SliderPaginationDots",
  y(va, ({ variants: p }) => {
    var u, h, m, c, i, g, v, W;
    const { totalSlides: o, currentSlide: r, settings: e, scrollToSlide: n, handleScroll: d } = P(), t = A.useRef([]), f = $({
      mobile: ((h = (u = e == null ? void 0 : e.pagination) == null ? void 0 : u.mobile) == null ? void 0 : h.template) === "dots",
      tablet: null,
      desktop: ((c = (m = e == null ? void 0 : e.pagination) == null ? void 0 : m.desktop) == null ? void 0 : c.template) === "dots"
    }), s = na.styles(p);
    if (!d || !n)
      return;
    if (((g = (i = e == null ? void 0 : e.pagination) == null ? void 0 : i.mobile) == null ? void 0 : g.template) !== "dots" && ((W = (v = e == null ? void 0 : e.pagination) == null ? void 0 : v.desktop) == null ? void 0 : W.template) !== "dots")
      return null;
    const b = (C) => {
      var w, S;
      C.key === "ArrowLeft" && (d("left"), (w = t.current[r - 1]) == null || w.focus()), C.key === "ArrowRight" && (d("right"), (S = t.current[r + 1]) == null || S.focus());
    };
    return /* @__PURE__ */ l(
      "ul",
      {
        role: "tablist",
        className: s.wrapper,
        "data-can-scroll": o > 0,
        ...f,
        children: Array.from({ length: o }, (C, w) => /* @__PURE__ */ l(
          "li",
          {
            role: "presentation",
            className: s.listItem,
            children: /* @__PURE__ */ l(
              "button",
              {
                ref: (S) => t.current[w] = S,
                className: s.dot,
                onClick: () => n(w),
                onKeyDown: (S) => b(S),
                "data-active": w === r,
                role: "tab",
                tabIndex: w === r ? 0 : -1,
                "aria-label": `Object ${w + 1}`,
                "aria-selected": w === r
              }
            )
          },
          `indicator-dot-${w}`
        ))
      }
    );
  })
), ga = ({
  variants: p
}) => {
  var t, f, s, b, u, h, m, c;
  const { settings: o, canScroll: r, scrollProgress: e } = P(), n = $({
    mobile: ((f = (t = o == null ? void 0 : o.pagination) == null ? void 0 : t.mobile) == null ? void 0 : f.template) === "progress-bar",
    tablet: null,
    desktop: ((b = (s = o == null ? void 0 : o.pagination) == null ? void 0 : s.desktop) == null ? void 0 : b.template) === "progress-bar"
  });
  if (((h = (u = o == null ? void 0 : o.pagination) == null ? void 0 : u.mobile) == null ? void 0 : h.template) !== "progress-bar" && ((c = (m = o == null ? void 0 : o.pagination) == null ? void 0 : m.desktop) == null ? void 0 : c.template) !== "progress-bar")
    return null;
  const d = ia.styles(p);
  return /* @__PURE__ */ l("div", { className: d.wrapper, "data-can-scroll": r, children: /* @__PURE__ */ l(
    "div",
    {
      className: d.progressBar,
      style: {
        width: `${100 * (e ?? 0)}%`
      },
      ...n
    }
  ) });
}, Sa = ({
  variants: p
}) => {
  var f, s, b, u, h, m, c, i;
  const { totalSlides: o, currentSlide: r, settings: e, canScroll: n } = P(), d = $({
    mobile: ((s = (f = e == null ? void 0 : e.pagination) == null ? void 0 : f.mobile) == null ? void 0 : s.template) === "numbers",
    tablet: null,
    desktop: ((u = (b = e == null ? void 0 : e.pagination) == null ? void 0 : b.desktop) == null ? void 0 : u.template) === "numbers"
  });
  if (((m = (h = e == null ? void 0 : e.pagination) == null ? void 0 : h.mobile) == null ? void 0 : m.template) !== "numbers" && ((i = (c = e == null ? void 0 : e.pagination) == null ? void 0 : c.desktop) == null ? void 0 : i.template) !== "numbers")
    return null;
  const t = sa.styles(p);
  return /* @__PURE__ */ l("div", { className: t.wrapper, "data-can-scroll": n, ...d, children: /* @__PURE__ */ B("span", { className: t.numbers, children: [
    r + 1,
    " / ",
    o
  ] }) });
}, Ca = a.object({
  variants: a.custom().optional()
}), Na = k(
  "SliderPaginatonScrollBar",
  y(Ca, ({ variants: p }) => {
    var s, b, u, h, m, c, i, g;
    const { settings: o, scrollProgress: r, canScroll: e } = P(), n = $({
      mobile: ((b = (s = o == null ? void 0 : o.pagination) == null ? void 0 : s.mobile) == null ? void 0 : b.template) === "scrollbar",
      tablet: null,
      desktop: ((h = (u = o == null ? void 0 : o.pagination) == null ? void 0 : u.desktop) == null ? void 0 : h.template) === "scrollbar"
    });
    if (((c = (m = o == null ? void 0 : o.pagination) == null ? void 0 : m.mobile) == null ? void 0 : c.template) !== "scrollbar" && ((g = (i = o == null ? void 0 : o.pagination) == null ? void 0 : i.desktop) == null ? void 0 : g.template) !== "scrollbar")
      return null;
    const d = ca.styles(p), t = "100px", f = `translate3d(calc(-${(1 - (r ?? 0)) * 100}% + ${t}), 0, 0)`;
    return /* @__PURE__ */ l(
      "div",
      {
        className: d.wrapper,
        "data-can-scroll": e,
        style: { overflow: "hidden" },
        ...n,
        children: /* @__PURE__ */ l(
          "div",
          {
            style: {
              transform: f,
              width: `calc(100% - ${t})`,
              height: "100%"
            },
            children: /* @__PURE__ */ l(
              "div",
              {
                className: d.scrollbarThumb,
                style: { width: t, height: "100%", marginLeft: "auto" }
              }
            )
          }
        )
      }
    );
  })
), U = a.union([
  a.literal("dots"),
  a.literal("progress-bar"),
  a.literal("scrollbar"),
  a.literal("numbers"),
  a.undefined()
]), Y = a.object({
  variants: a.custom().optional(),
  templateBlueprint: a.custom().optional(),
  mobile: a.object({
    enabled: a.boolean().optional(),
    template: U.optional()
  }).optional(),
  desktop: a.object({
    enabled: a.boolean().optional(),
    template: U.optional()
  }).optional(),
  "aria-controls": a.string().optional(),
  "aria-label": a.string().optional()
}), Wa = k(
  "SwiperPagination",
  y(
    Y,
    ({
      templateBlueprint: p,
      variants: o,
      "aria-controls": r,
      "aria-label": e
    }) => {
      var f, s, b, u;
      const { settings: n } = P(), t = (p ?? pa).styles(o);
      return !((s = (f = n == null ? void 0 : n.pagination) == null ? void 0 : f.mobile) != null && s.enabled) && !((u = (b = n == null ? void 0 : n.pagination) == null ? void 0 : b.desktop) != null && u.enabled) ? null : /* @__PURE__ */ B(
        "div",
        {
          className: t.wrapper,
          role: "tablist",
          "aria-label": e || "Carousel pagination",
          "aria-controls": r,
          children: [
            /* @__PURE__ */ l(fa, { "aria-controls": r }),
            /* @__PURE__ */ l(ga, { "aria-controls": r }),
            /* @__PURE__ */ l(Na, { "aria-controls": r }),
            /* @__PURE__ */ l(Sa, { "aria-controls": r })
          ]
        }
      );
    }
  )
), ya = a.object({
  variants: a.custom().optional(),
  templateBlueprint: a.custom().optional(),
  className: a.string().optional()
}), xa = k(
  "SwiperList",
  y(ya, ({ variants: p, templateBlueprint: o, className: r }) => {
    const n = (o ?? ua).styles(p), {
      currentSlide: d,
      items: t,
      setScrollX: f,
      sliderRef: s,
      itemsWrapperClass: b,
      handleScroll: u,
      scrollToSlide: h
    } = P(), m = G(null), c = (i) => {
      if (!(!u || !h))
        switch (i.key) {
          case "ArrowLeft":
            i.preventDefault(), u("left");
            break;
          case "ArrowRight":
            i.preventDefault(), u("right");
            break;
          case "Home":
            i.preventDefault(), h(0);
            break;
          case "End":
            i.preventDefault(), h(A.Children.count(t) - 1);
            break;
        }
    };
    return M(() => {
      if (m.current) {
        const i = m.current.querySelectorAll('[role="group"]');
        i[d] && i[d].focus();
      }
    }, [d]), /* @__PURE__ */ l(
      "section",
      {
        className: J(n.wrapper, r, b),
        ref: s,
        onScroll: (i) => f(i.currentTarget.scrollLeft),
        onKeyDown: c,
        tabIndex: 0,
        role: "region",
        "aria-roledescription": "carousel",
        "aria-label": "Carousel slides",
        children: A.Children.map(t, (i, g) => /* @__PURE__ */ l(
          "div",
          {
            className: n.item,
            "data-featured": g === d ? "true" : "false",
            role: "group",
            "aria-roledescription": "slide",
            "aria-label": `Slide ${g + 1}`,
            tabIndex: g === d ? 0 : -1,
            onClick: () => h == null ? void 0 : h(g),
            children: i
          },
          g
        ))
      }
    );
  })
), H = a.object({
  template: a.literal("template1"),
  variants: a.custom().optional(),
  headerSettings: a.object({
    heading: ha.optional(),
    link: E.optional()
  }).optional(),
  /**
   * @deprecated Use headerSettings.link instead
   */
  link: E.optional(),
  linkPlacement: a.enum(["header", "footer"]).optional(),
  linkBelowList: E.optional(),
  navigationPlacement: a.enum(["header", "in-list"]).optional()
}), ka = k(
  "SwiperTemplate1",
  y(
    {
      schema: H,
      defaultProps: {
        template: "template1",
        navigationPlacement: "in-list"
      }
    },
    ({
      variants: p,
      headerSettings: o,
      linkBelowList: r,
      navigationPlacement: e,
      linkPlacement: n = "header",
      link: d
    }) => {
      var W, C, w, S;
      const {
        rootWrapperClass: t,
        maxWidthWrapperClass: f,
        headerWrapperClass: s,
        linkBelowListWrapperClass: b,
        listWrapperClass: u,
        currentSlide: h,
        totalSlides: m
      } = P(), c = ma.styles(p), i = ((W = o == null ? void 0 : o.heading) == null ? void 0 : W.heading) || ((C = o == null ? void 0 : o.link) == null ? void 0 : C.label) || ((w = o == null ? void 0 : o.heading) == null ? void 0 : w.eyebrow), g = ea(), v = (o == null ? void 0 : o.link) ?? d;
      return /* @__PURE__ */ l(
        "section",
        {
          className: j("min-w-[1px]", c.wrapper, t),
          "aria-roledescription": "carousel",
          "aria-label": ((S = o == null ? void 0 : o.heading) == null ? void 0 : S.heading) || "Content carousel",
          id: g,
          children: /* @__PURE__ */ B(
            "div",
            {
              className: j(
                c.container,
                f,
                "@container"
              ),
              children: [
                i && /* @__PURE__ */ B(
                  "div",
                  {
                    className: j(s, c.header),
                    "data-placement": n,
                    "aria-label": "Carousel header",
                    children: [
                      /* @__PURE__ */ l(wa, { ...o == null ? void 0 : o.heading }),
                      (v == null ? void 0 : v.label) && n === "header" && /* @__PURE__ */ l(
                        K,
                        {
                          ...v,
                          className: c.link,
                          "aria-label": `${v == null ? void 0 : v.label} - opens in new tab`
                        }
                      ),
                      e === "header" && /* @__PURE__ */ l(
                        F,
                        {
                          "aria-controls": g,
                          "aria-label": "Carousel navigation"
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ B(
                  "div",
                  {
                    className: j(c.listWrapper, u),
                    "aria-live": "polite",
                    "aria-atomic": "true",
                    children: [
                      /* @__PURE__ */ l(
                        xa,
                        {
                          className: c.list,
                          "aria-label": `Slide ${h + 1} of ${m}`
                        }
                      ),
                      e === "in-list" && /* @__PURE__ */ l(
                        F,
                        {
                          "aria-controls": g,
                          "aria-label": "Carousel navigation"
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ l(
                  Wa,
                  {
                    "aria-controls": g,
                    "aria-label": "Carousel pagination"
                  }
                ),
                (r == null ? void 0 : r.label) && /* @__PURE__ */ l(
                  K,
                  {
                    ...r,
                    className: j(b, c.linkBelowList),
                    "aria-label": `${r == null ? void 0 : r.label} - opens in new tab`
                  }
                ),
                (v == null ? void 0 : v.label) && n === "footer" && /* @__PURE__ */ l(
                  "div",
                  {
                    className: j(s, c.linkWrapper),
                    "data-placement": n,
                    children: /* @__PURE__ */ l(
                      K,
                      {
                        ...v,
                        className: c.link,
                        "aria-label": `${v == null ? void 0 : v.label} - opens in new tab`
                      }
                    )
                  }
                )
              ]
            }
          )
        }
      );
    }
  )
), Pa = a.object({
  pagination: Y.optional(),
  navigation: Q.optional(),
  itemsInView: a.custom().optional(),
  spacing: a.custom().optional()
}), R = a.discriminatedUnion("template", [
  H.merge(Pa)
]), Ia = y(R, (p) => {
  switch (p.template) {
    case "template1":
      return /* @__PURE__ */ l(ka, { ...p });
    default:
      return null;
  }
}), V = a.object({
  settings: R.optional(),
  children: a.custom()
}), ja = V.extend({
  items: V.shape.children,
  sliderRef: a.custom().nullable()
});
a.object({
  /** Configuration settings for the swiper component */
  settings: V.shape.settings,
  /** Array of items/slides to be displayed in the swiper */
  items: V.shape.children,
  /** Current horizontal scroll position in pixels */
  scrollX: a.number(),
  /** Function to update horizontal scroll position */
  setScrollX: a.custom(),
  /** Width of the swiper container in pixels */
  containerWidth: a.number(),
  /** Function to update container width */
  setContainerWidth: a.custom(),
  /** Total number of slides in the swiper */
  totalSlides: a.number(),
  /** Current active slide index (0-based) */
  currentSlide: a.number(),
  /** Function to update current slide index */
  setCurrentSlide: a.custom(),
  /** Reference to the slider DOM element */
  sliderRef: a.custom().nullable(),
  /**
   * Handler for scroll navigation
   * @param direction - Direction to scroll ('left' or 'right')
   */
  handleScroll: a.function().args(a.enum(["left", "right"])).returns(a.void()).optional(),
  /**
   * Function to scroll to a specific slide
   * @param index - Index of the target slide
   */
  scrollToSlide: a.function().args(a.number()).returns(a.void()).optional(),
  /** Whether scrolling is currently possible */
  canScroll: a.boolean(),
  /** Current scroll progress (0 to 1) */
  scrollProgress: a.number().optional(),
  /** CSS class for the root wrapper element, needed itemsInView to work */
  rootWrapperClass: a.string().optional(),
  /** CSS class for the root wrapper element, needed itemsInView to work */
  itemsWrapperClass: a.string().optional(),
  /** CSS class for the max-width wrapper element, needed max-width to work */
  maxWidthWrapperClass: a.string().optional(),
  /** CSS class for the list wrapper element, needed @container to work */
  listWrapperClass: a.string().optional(),
  /** CSS class for the header wrapper element, needed @container to work */
  headerWrapperClass: a.string().optional(),
  /** CSS class for the link below list wrapper element, needed @container to work */
  linkBelowListWrapperClass: a.string().optional()
});
const aa = A.createContext(
  void 0
), Ba = k(
  "SwiperProvider",
  y(
    ja,
    ({ children: p, items: o, settings: r, sliderRef: e }) => {
      var W, C;
      const [n, d] = X(0), [t, f] = X(0), [s, b] = X(0), u = A.Children.count(o), h = da.styles({
        itemsInView: (r == null ? void 0 : r.itemsInView) ?? {}
      }), m = ba.styles(r == null ? void 0 : r.spacing), c = (w) => {
        if (!(e != null && e.current))
          return;
        const S = e.current.clientWidth, N = w === "left" ? n - S : n + S;
        e.current.scrollTo({
          left: N,
          behavior: "smooth"
        });
      };
      if (!o)
        return null;
      const i = (w) => {
        if (!(e != null && e.current) || s === w)
          return;
        const N = Array.from(e.current.children)[w];
        N && N.scrollIntoView({ behavior: "smooth", block: "nearest" });
      };
      M(() => {
        e != null && e.current && f(
          e.current.scrollWidth - e.current.offsetWidth
        );
      }, [(W = e == null ? void 0 : e.current) == null ? void 0 : W.scrollWidth, (C = e == null ? void 0 : e.current) == null ? void 0 : C.offsetWidth]), M(() => {
        if (!(e != null && e.current))
          return;
        const w = Array.from(e.current.children), S = new IntersectionObserver(
          (N) => {
            N.forEach((L) => {
              if (L.isIntersecting) {
                const D = N.filter(
                  (x) => x.isIntersecting
                );
                D.sort(
                  (x, T) => x.boundingClientRect.left - T.boundingClientRect.left
                );
                const I = D[0], O = w.findIndex(
                  (x) => x === (I == null ? void 0 : I.target)
                );
                b(O);
              }
            });
          },
          { threshold: 0.5, rootMargin: "0px 0px -50% 0px" }
        );
        return w.forEach((N) => S.observe(N)), () => S.disconnect();
      }, [e, s, u]);
      const g = !Number.isNaN(n / t), v = n / t;
      return /* @__PURE__ */ l(
        aa.Provider,
        {
          value: {
            settings: r,
            items: o,
            scrollX: n,
            setScrollX: d,
            containerWidth: t,
            setContainerWidth: f,
            totalSlides: u,
            currentSlide: s,
            rootWrapperClass: J(
              h.wrapper,
              m.wrapper
            ),
            itemsWrapperClass: h.item,
            maxWidthWrapperClass: m.maxWidthWrapper,
            listWrapperClass: m.listWrapperVars,
            headerWrapperClass: m.headerWrapperVars,
            linkBelowListWrapperClass: m.linkBelowListWrapperVars,
            setCurrentSlide: b,
            sliderRef: e,
            scrollToSlide: i,
            handleScroll: c,
            canScroll: g,
            scrollProgress: v
          },
          children: p
        }
      );
    }
  )
), P = () => {
  const p = A.useContext(aa);
  if (!p)
    throw new Error("useSwiperContext must be used within a SwiperProvider");
  return p;
}, Aa = () => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16.67 12.09", children: /* @__PURE__ */ l("path", { d: "M16.52,5.68c-.09-.09-.22-.15-.36-.15H1.76L6.41.88c.2-.2.2-.53,0-.73s-.53-.2-.73,0L.15,5.68c-.2.2-.2.53,0,.73l5.53,5.53c.2.2.53.2.73,0s.2-.53,0-.73L1.76,6.56h14.39c.28,0,.51-.23.51-.51,0-.14-.06-.27-.15-.36Z" }) }), Da = () => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16.67 12.09", children: /* @__PURE__ */ l("path", { d: "M.15,6.41c.09.09.22.15.36.15h14.39l-4.65,4.65c-.2.2-.2.53,0,.73s.53.2.73,0l5.53-5.53c.2-.2.2-.53,0-.73L10.99.15c-.2-.2-.53-.2-.73,0s-.2.53,0,.73l4.65,4.65H.51c-.28,0-.51.23-.51.51,0,.14.06.27.15.36Z" }) }), _ = "template1", oa = ta(!1), Fa = () => ra(oa), Va = k(
  "Swiper",
  y(
    {
      schema: V,
      defaultProps: {
        settings: {
          template: _,
          navigation: {
            prevIcon: /* @__PURE__ */ l(Aa, {}),
            nextIcon: /* @__PURE__ */ l(Da, {}),
            mobile: {
              enabled: !1
            },
            desktop: {
              enabled: !0
            }
          },
          pagination: {
            mobile: {
              enabled: !0,
              template: "dots"
            },
            desktop: {
              enabled: !0,
              template: "scrollbar"
            }
          },
          itemsInView: {
            initial: "2.5",
            md: "3.5",
            lg: "5"
          },
          spacing: {
            x: {
              initial: "lg",
              lg: "lg"
            },
            y: "lg",
            gap: "sm"
          }
        }
      }
    },
    ({ children: p, settings: o }) => {
      const r = G(null);
      return /* @__PURE__ */ l(
        Ba,
        {
          settings: { template: "template1", ...o },
          items: p,
          sliderRef: r,
          children: /* @__PURE__ */ l(oa.Provider, { value: !0, children: /* @__PURE__ */ l(
            Ia,
            {
              template: (o == null ? void 0 : o.template) ?? _,
              ...o
            }
          ) })
        }
      );
    }
  )
);
Va.displayName = "Swiper";
export {
  Aa as ArrowLeft,
  Da as ArrowRight,
  fa as Dots,
  xa as List,
  F as Navigation,
  Sa as Numbers,
  Wa as Pagination,
  ga as ProgressBar,
  Na as ScrollBar,
  Ia as SelectTemplate,
  Va as Swiper,
  Ba as SwiperProvider,
  ka as SwiperTemplate1,
  va as sliderPaginationDotsSchema,
  Ca as sliderPaginatonScrollBarSchema,
  ya as swiperListSchema,
  Q as swiperNavigationSchema,
  Y as swiperPaginationSchema,
  V as swiperPropsSchema,
  R as swiperSchema,
  H as swiperTemplate1Schema,
  Fa as useInSwiper,
  P as useSwiperContext
};
//# sourceMappingURL=index.es.js.map
